(() => {
  if (window.bfHeroCopyFit) return;
  window.bfHeroCopyFit = true;
  const fit = () => {
    document.querySelectorAll('.bf-m-hero__headline,.bf-home-hero__headline,.bf-pc-hero__headline').forEach(el => {
      el.style.removeProperty('font-size');
      const mobile = window.innerWidth <= (el.classList.contains('bf-home-hero__headline') ? 749 : 767);
      if (!el.getClientRects().length) return;
      // Preserve Figma sizing with Roboto; shrink only when a fallback font is wider.
      const width = el.getBoundingClientRect().width;
      const available = mobile ? width * 358 / 390 : width;
      if (el.scrollWidth > available) {
        const size = parseFloat(getComputedStyle(el).fontSize);
        el.style.fontSize = (size * available / el.scrollWidth) + 'px';
      }
    });
  };
  fit();
  window.addEventListener('resize', fit);
  document.addEventListener('shopify:section:load', fit);
  if (document.fonts) {
    document.fonts.ready.then(fit);
    if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', fit);
  }
})();
